import React, { useEffect } from 'react';
import { RotateCcwIcon, RotateCwIcon, CopyIcon, TrashIcon, LayersIcon, UnlinkIcon, ClipboardIcon, ClipboardPasteIcon } from 'lucide-react';
interface CircularToolbarProps {
  position: {
    x: number;
    y: number;
  };
  visible: boolean;
  onClose: () => void;
  onAction: (action: string) => void;
}
export function CircularToolbar({
  position,
  visible,
  onClose,
  onAction
}: CircularToolbarProps) {
  // Close when clicking outside
  useEffect(() => {
    if (!visible) return;
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.circular-toolbar')) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [visible, onClose]);
  if (!visible) return null;
  const actions = [{
    id: 'rotateLeft',
    icon: RotateCcwIcon,
    label: 'Rotate Left'
  }, {
    id: 'rotateRight',
    icon: RotateCwIcon,
    label: 'Rotate Right'
  }, {
    id: 'duplicate',
    icon: CopyIcon,
    label: 'Duplicate'
  }, {
    id: 'group',
    icon: LayersIcon,
    label: 'Group'
  }, {
    id: 'ungroup',
    icon: UnlinkIcon,
    label: 'Ungroup'
  }, {
    id: 'copyStyle',
    icon: ClipboardIcon,
    label: 'Copy Style'
  }, {
    id: 'pasteStyle',
    icon: ClipboardPasteIcon,
    label: 'Paste Style'
  }, {
    id: 'delete',
    icon: TrashIcon,
    label: 'Delete'
  }];
  const radius = 80;
  const angleStep = 2 * Math.PI / actions.length;
  return <div className="circular-toolbar fixed z-50" style={{
    left: position.x,
    top: position.y,
    transform: 'translate(-50%, -50%)'
  }} data-id="element-52">
      {/* Center button */}
      <button onClick={onClose} className="absolute z-10 w-10 h-10 bg-white dark:bg-darkbg-secondary rounded-full shadow-lg flex items-center justify-center border border-gray-200 dark:border-darkbg-border hover:bg-gray-50 dark:hover:bg-darkbg-primary" style={{
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }} data-id="element-53">
        <span className="text-gray-500 dark:text-gray-400" data-id="element-54">✕</span>
      </button>
      {/* Action buttons */}
      {actions.map((action, index) => {
      const angle = index * angleStep - Math.PI / 2;
      const x = radius * Math.cos(angle);
      const y = radius * Math.sin(angle);
      return <button key={action.id} onClick={() => {
        onAction(action.id);
        onClose();
      }} className="absolute w-10 h-10 bg-white dark:bg-darkbg-secondary rounded-full shadow-lg flex items-center justify-center border border-gray-200 dark:border-darkbg-border hover:bg-blue-50 dark:hover:bg-darkbg-primary hover:border-blue-500 dark:hover:border-accent-blue transition-colors" style={{
        left: `calc(50% + ${x}px)`,
        top: `calc(50% + ${y}px)`,
        transform: 'translate(-50%, -50%)'
      }} title={action.label} data-id="element-55">
            <action.icon className="h-4 w-4 text-gray-700 dark:text-gray-300" data-id="element-56" />
          </button>;
    })}
    </div>;
}